import React from 'react'
import PropTypes from 'prop-types'

import { Box, Paper, Typography } from '@material-ui/core'

import useStyles from './styles'

const StatsCard = ({
  icon,
  label,
  subLabel,
  value,
  backgroundColor = '#f5f5f5',
  onClick,
  selected = false,
}) => {
  const classes = useStyles({
    backgroundColor,
    selected,
    clickable: Boolean(onClick),
  })

  return (
    <Box className={classes.root} component={Paper} onClick={onClick}>
      {icon ? (
        <Box className={classes.iconContainer}>
          <Box className={classes.icon}>{icon}</Box>
        </Box>
      ) : (
        <Box className={classes.colorBar} />
      )}

      <Box pl={2} className={classes.content}>
        <Typography className={classes.value} noWrap>
          {value}
        </Typography>

        <Typography className={classes.label} noWrap>
          {label}
        </Typography>

        {subLabel && (
          <Typography className={classes.subLabel} noWrap>
            {subLabel}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

StatsCard.propTypes = {
  icon: PropTypes.element,
  label: PropTypes.string.isRequired,
  subLabel: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  backgroundColor: PropTypes.string,
  onClick: PropTypes.func,
  selected: PropTypes.bool,
}

export default StatsCard
